import type { RegisteredComponent } from "@builder.io/sdk-react";

import ModelMap from "~/hec/builder/model-map";

interface AlertBarProps {
  children?: React.ReactNode;
  attributes?: Record<string, unknown>;
}

const AlertBar = ({ children, attributes }: AlertBarProps) => (
  <div {...(attributes ?? {})}>{children}</div>
);

export const AlertBarDefinition = {
  component: AlertBar,
  name: "AlertBar",
  // override: true tells Builder to replace any previously-registered block
  // with this name — matches composable definition exactly.
  override: true,
  noWrap: true,
  canHaveChildren: true,
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  image: "https://unpkg.com/css.gg@2.0.0/icons/svg/info.svg",
  inputs: [
    // Editor-only inputs for previewing TPA banners in the Builder editor.
    // Actual TPA banner rendering at runtime is deferred to SFCC-11087
    // (depends on TPA-Auth infra in SFCC-11057/11058).
    {
      name: "displayTpaBannerInEditor",
      type: "boolean",
      defaultValue: false,
      friendlyName: "Preview TPA banner in editor",
    },
    {
      name: "tpaBannerToDisplayInEditor",
      type: "reference",
      model: ModelMap.tpaWelcomeBanner,
      required: true,
      friendlyName: "TPA banner to preview",
      showIf: `options.get('displayTpaBannerInEditor') === true`,
    },
  ],
} satisfies RegisteredComponent;
